import { Link } from "react-router-dom";
import { RippLayout } from "./ui";

const TAG = { fontFamily: "'Permanent Marker', cursive" };

const PHASES = [
  ["01", "IGNITION", "now", [
    "The Core is live: Meme Hunter, Market Trader (Bitcoin + stock market), Wallet Tracker, Launch Sniper and the Hive",
    "Every entry and exit logged in public at ripp.xyz",
    "RIPP Telegram channel, community chat and X live — the lore and Mav, our 1/1 Legendary mascot, revealed",
    "Launch countdown: $RIPP goes live Friday, November 6 at 12:00 PM ET",
  ]],
  ["02", "THE CROWN DROPS", "$RIPP launch", [
    "$RIPP fair-launches on Pump.fun — no presale, no team allocation",
    "Official contract address posted only in t.me/Ripplabs and on x.com/RippLabs_",
    "DexScreener verified profile, logo and links",
    "Push to graduation and open trading",
  ]],
  ["03", "GENESIS", "72 hours after launch", [
    "RIPP Genesis NFT mint opens — 25 pieces",
    "Genesis founder badge, serial and first access to every future drop",
    "Holder dashboard goes live, unlocked by your NFT",
  ]],
  ["04", "THE HIVE OPENS", "holder access", [
    "Tiered access by rarity: Core, Core+, Hive, Elite",
    "Hive signals, research feeds and enhanced alerts for holders",
    "$RIPP utility — hold $RIPP to unlock premium strategy modes",
    "Full RIPP collection rolls out toward the 1,000 cap",
  ]],
  ["05", "YOUR OWN RIPP", "Legendary", [
    "Legendary holders get their own RIPP trading for them",
    "Personal desks: memes, Bitcoin and the stock market under one machine",
    "Mobile alerts for every move your RIPP makes",
  ]],
  ["06", "EVERY ANGLE", "expansion", [
    "More markets and more chains plugged into the Core",
    "More Hive sources feeding the Core around the clock",
    "Community votes on the next desk RIPP takes on",
  ]],
];

function Phase({ n, title, when, items, i }) {
  const now = i === 0;
  return (
    <div className="relative pl-14 pb-14 last:pb-0" data-testid={`roadmap-phase-${n}`}>
      <span className={`absolute left-0 top-0 h-10 w-10 rounded-full grid place-items-center text-sm font-black ${now ? "bg-[#F5C451] text-black shadow-[0_0_30px_rgba(245,196,81,0.5)]" : "border border-[#F5C451]/40 text-[#F5C451]"}`}>{n}</span>
      <div className="flex flex-wrap items-baseline gap-3">
        <h2 className="text-2xl lg:text-3xl text-[#F5C451]" style={TAG}>{title}</h2>
        <span className={`text-[10px] tracking-[0.3em] uppercase px-2 py-1 rounded-full ${now ? "bg-[#F5C451]/15 text-[#F5C451]" : "text-white/40 border border-white/10"}`}>{now ? "in progress" : when}</span>
      </div>
      <ul className="mt-4 space-y-2 text-white/65 text-sm lg:text-base">
        {items.map((t) => <li key={t} className="flex gap-3"><span className="text-[#F5C451]/70">▸</span><span>{t}</span></li>)}
      </ul>
    </div>
  );
}

export function RippRoadmap() {
  return (
    <RippLayout>
      <style>{"@import url('https://fonts.googleapis.com/css2?family=Permanent+Marker&display=swap');"}</style>
      <section className="grid lg:grid-cols-[1.2fr_0.8fr] gap-12 items-center" data-testid="roadmap-hero">
        <div>
          <div className="text-[11px] tracking-[0.4em] text-[#F5C451]/80 mb-6">$RIPP · THE ROADMAP</div>
          <h1 className="text-5xl lg:text-7xl font-black leading-[0.95] tracking-tight">Every angle.<br /><span className="text-[#F5C451]" style={TAG}>One machine.</span></h1>
          <p className="mt-8 text-white/60 max-w-xl text-sm lg:text-base leading-relaxed">Milestones, not promises. Each phase unlocks when the last one is done — and every step is logged in public.</p>
        </div>
        <img src="/lore/crown_graffiti.jpg" alt="RIPP crown" className="w-full max-w-xs mx-auto rounded-3xl border border-[#F5C451]/20" data-testid="roadmap-crown-img" />
      </section>
      <section className="mt-24 relative max-w-3xl" data-testid="roadmap-phases">
        <div className="absolute left-5 top-2 bottom-2 w-px bg-gradient-to-b from-[#F5C451] via-[#F5C451]/30 to-transparent" />
        {PHASES.map(([n, title, when, items], i) => <Phase key={n} n={n} title={title} when={when} items={items} i={i} />)}
      </section>
      <section className="mt-24 mb-10 flex flex-wrap gap-4">
        <a href="https://t.me/+FZyNGifYYd0zNWUx" target="_blank" rel="noreferrer" className="px-6 py-3 rounded-full bg-[#F5C451] text-black text-xs font-bold tracking-widest" data-testid="roadmap-telegram-btn">JOIN THE CHANNEL</a>
        <Link to="/ripp/lore" className="px-6 py-3 rounded-full border border-[#F5C451]/60 text-[#F5C451] text-xs font-bold tracking-widest hover:bg-[#F5C451]/10" data-testid="roadmap-lore-btn">READ THE LORE</Link>
      </section>
    </RippLayout>
  );
}
